import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Accordions from '../../../Litho/Components/Accordion/Accordion';
import Buttons from '../../../Litho/Components/Button/Buttons';
import CustomModal from '../../../Litho/Components/CustomModal';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const AccordionData = [
  {
    title: 'What is the difference between FCL and LCL?',
    content:
      'FCL is a full-container load, LCL is consolidated cargo sharing a container.',
  },
  {
    title: 'Do you handle customs documentation?',
    content:
      'Yes, we provide brokerage and documentation support for export/import.',
  },
  {
    title: 'Can you ship temperature-controlled goods?',
    content: 'Yes, with reefer containers and specialized handling.',
  },
];

const FAQVideo = () => {
  return (
    <section className='p-0 bg-darkgray'>
      <Container fluid>
        <Row>
          <Col
            lg={6}
            className='p-[8.5rem] lg:p-[5.5rem] xs:px-[15px] bg-no-repeat bg-[top_-45px_left]'
            style={{
              backgroundImage: `url(assets/img/services/our-process-bg-4.webp)`,
            }}
          >
            <h5 className='font-serif font-medium text-white mb-16'>
              Ocean freight FAQs and tips
            </h5>
            <Accordions
              theme='accordion-style-02'
              className=''
              animation={fadeIn}
              themeColor='dark'
              data={AccordionData}
            />
          </Col>
          <Col
            style={{
              backgroundImage: `url(assets/img/services/page-heade-bg.jpg)`,
            }}
            className='cover-background md:h-[550px] relative sm:h-[400px] xs:h-[300px]'
          ></Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQVideo;
